var _effectorFileName = "/src/page-content/public-offer/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const publicOfferPage = declarePage({
  pageType: pagesPath.$url().pathname
});